import { render, staticRenderFns } from "./carnets.vue?vue&type=template&id=10147c8c&"
import script from "./carnets.vue?vue&type=script&lang=js&"
export * from "./carnets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports